const baseUrl: string = '/section'

export const pay: string = `${baseUrl}/pay`
export const notFound: string = `${baseUrl}/not-found`

export const mga: string = 'https://consultoriomga.com/'
export const mgaTestPay: string = 'https://consultoriomga.com/test-vocacional-online-pay'

export const generateLinkTestVocational: string = `${baseUrl}/test`
